import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { FlyInModalArgs, ModalArgs } from '../../models/modal';
import { ModalService } from '../../services/modal.service';

@Component({
  selector: 'fly-in-modal',
  templateUrl: './fly-in-modal.component.html',
  styleUrls: ['./fly-in-modal.component.scss'],
  standalone: false
})
export class FlyInModalComponent implements OnInit, OnDestroy {
  @ViewChild('flyInModalRef', { static: true }) public flyInModalRef: TemplateRef<any>;

  private sub: Subscription;
  public content: TemplateRef<any>;
  public header: string;

  constructor(
    private modalService: ModalService,
    private ngbModalService: NgbModal
  ) {}

  ngOnInit() {
    this.sub = this.modalService.flyInModalToggle.subscribe((value: FlyInModalArgs) => {
      this._openModal(value);
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  private _openModal(value: FlyInModalArgs) {
    this.content = value.Content;
    this.header = value.Header;

    this.ngbModalService
      .open(this.flyInModalRef, {
        size: 'lg',
        windowClass: 'fly-in-from-left',
        animation: false
      })
      .result.then(
        // close
        () => {},
        // dismiss
        () => {}
      );
  }
}
